import {NgModule} from '@angular/core';
import {FormValidationComponent} from '@app/common/form-validation/form-validation.component';
import {CommonModule} from '@angular/common';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxIntlTelInputModule} from '@app/common/ngx-intl-tel-input';
import {SpinnerComponent} from '@app/common/spinner/spinner.components';
import {NgsRevealModule} from 'ngx-scrollreveal';
import {NbRadioModule} from '@nebular/theme';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {FilterPipe} from '@app/pipes/filter.pipe';
import {NbTreeGridModule, NbAccordionModule, NbAutocompleteModule} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {ClipboardModule} from 'ngx-clipboard';
import {SvgComponent} from '@app/common/svg/svg.component';
import {ContentfulService} from '@app/services/contentful.service';
import {SafeHtmlPipe} from '@app/pipes/safe-html.pipe';
import {SortByPipe} from '@app/pipes/sort-by.pipe';
import {MatChipsModule} from '@angular/material/chips';
import {MatInputModule} from '@angular/material/input';
import {MatTreeModule} from '@angular/material/tree';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DragDropModule} from '@angular/cdk/drag-drop';

const commonModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  NgxIntlTelInputModule,
  NgsRevealModule,
  NbRadioModule,
  NbTreeGridModule,
  ClipboardModule,
  NbEvaIconsModule,
  NbAccordionModule,
  NbAutocompleteModule,
  MatChipsModule,
  MatMenuModule,
  MatTooltipModule,
  DragDropModule,
  MatInputModule,
  MatAutocompleteModule,
  MatTreeModule
];

const commonComponents = [
  FormValidationComponent,
  SpinnerComponent,
  FilterPipe,
  SvgComponent,
  SafeHtmlPipe,
  SortByPipe
];

@NgModule({
  imports: [
    ...commonModules, BsDatepickerModule.forRoot(), CarouselModule.forRoot()
  ],
  declarations: commonComponents,
  exports: [...commonComponents, ...commonModules, BsDatepickerModule],
  providers: [ContentfulService]
})
export class SbCommonModule {
}
